module.exports = {
      id: "myvikatanbadge-usage",
      viewBox: "0 0 499.854 524.656",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#myvikatanbadge",
      toString: function () {
        return this.url;
      }
    }